import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { CompliantLocalStorageKeys } from '@wix/da-react-context/pkg/compliantLocalStorage/redux/constants';
import { getCompliantLocalStorageItem } from '@wix/da-react-context/pkg/compliantLocalStorage/redux/selectors';
import { doNotShowAgainChanged } from '../../Modals/redux/actionCreators';
import { Props } from './ConfirmationModal';

export type StateProps = Pick<Props, 'autoAcceptForDoNotShow'>;
export type DispatchProps = Pick<Props, 'onDoNotShowAgainChange'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)> & {};

export const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = (state, ownProps) => {
  const dnsDb = getCompliantLocalStorageItem(state, CompliantLocalStorageKeys.DO_NOT_SHOW_AGAIN);
  let autoAccept = false;
  if (dnsDb) {
    try {
      const dnsItems = JSON.parse(dnsDb);
      autoAccept = dnsItems[ownProps.doNotShowAgainKey || ''];
    } catch {}
  }
  return {
    autoAcceptForDoNotShow: autoAccept,
  };
};
export const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  props
) => ({
  onDoNotShowAgainChange: (key, value) => dispatch(doNotShowAgainChanged(key, value)),
});

export default connect(mapStateToProps, mapDispatchToProps);
